<template>
   <div class="loading-overlay" id="loadingOverlay" style="display: none;">
  <div class="spinner-container">
    <div class="spinner"></div>
    <div class="loading-text">Please wait...</div>
  </div>
</div>


    <vue-basic-alert :duration="300" :closeIn="2000" ref="alert" />
    <div class="register-container">
        <div class="register-form-container">
            <form id="addBankAccForm" @submit="handleSubmit" novalidate autocomplete="off">
                <div class="heading">
                    <h3>Select Property to generate form K</h3>
                    
                </div>
                 <div class="row">                    
                    <div class="col-sm-2">  
                            
                            <label for="ward"><b>Ward Number  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</b>
                     </label>
                     <select v-model="CatObj.ward" id="ward" class="form-control"  size="5">
                          <option value="" selected disabled>
                               Choose
                           </option>
                          <option v-for="m in savedWards" :key="m.ward_id" id="Hid"  
                          v-bind:value =m.ward_id>
                             <div>{{m.ward }}</div> 
                          </option>
                      </select>
                    
                                
                     <p class="error-mess" v-if="aserrObj.wardErr.length > 0">{{ aserrObj.wardErr[0] }}</p>
                  </div>
                  <div class="col-sm-4">  
                            
                            <label for="street"><b>Name of Road,or Street  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</b>
                     </label>
                     <!-- <select v-model="CatObj.street" id="street" class="form-control" @change="SearchByraod()" size="5"> -->
                     <select v-model="CatObj.street" id="street" class="form-control"  size="5">
                          <option value="" selected disabled>
                               Choose
                           </option>
                          <option v-for="m in savedStreets" :key="m.street_id" id="Hid"  
                          v-bind:value =m.street_id>
                             <div>{{m.street_name }}</div> 
                          </option>
                      </select>
                                
                      <p class="error-mess" v-if="aserrObj.stretErr.length > 0">{{ aserrObj.stretErr[0] }}</p>
                  </div>
                    <div class="col-sm-2">  
                            
                            <label for="side"><b>Left/Right  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</b>
                     </label>
                     <select v-model="CatObj.side" id="side" class="form-control" @change="SearchByside()" size="5">
                          <option value="" selected disabled>
                               Choose
                           </option>
                          <option value="Left">
                            Left
                          </option>
                          <option value="Right">
                            Right
                          </option>
                      </select>
                                
                      <!-- <p class="error-mess" v-if="aserrObj.stretErr.length > 0">{{ aserrObj.stretErr[0] }}</p> -->
                  </div>
                  <div class="col-sm-4">
                 <label for="cat"><b>Assessment Number:</b>
                 </label>
                    <select v-model="CatObj.assenum" id="cat" class="form-control" size="5" @change="genByAssNum()">
                          <!-- <option value="" selected disabled>
                               Choose
                           </option> -->
                          <option v-for="m in propertydetails" :key="m.property_id" id="Hid"  
                          v-bind:value =m.property_id>
                             <div>{{m.asses_num }}</div> 
                          </option>
                      </select>
                  

                 <!-- <p class="error-mess" v-if="errObj.maincErr.length > 0">{{ errObj.maincErr[0] }}</p> -->
             </div>
                 
                </div>
              </form>
   <br>
   <!-- <button @click="previewPDF">Preview & Download PDF</button> -->

     <button @click="printpdf" class="btn"> Print Forms K</button>&nbsp;&nbsp;
      <button @click="downloadPDF" class="btn">Download List of Statutary Assessment Notice</button>

  <div ref="pdfContent" class="print-container">
     <div v-for="(property, index) in propertydetails" :key="index" class="property-block">
 <div class="heading">
           <!-- <h4 style="text-align: center;">Statutary Notice of Assessment</h4> -->
           <h4 style="text-align: center; font-size: 14px;">
           ව්‍යවස්ථාපිත තක්සේරු දැන්වීමයි /கட்டளை சட்டப்படியான வரி மதிப்பு அறிவித்தல்/ Statutary Notice of Assessment<br>
                        <!-- {{sabhadetail.sb_name_en}}, -->
                  {{sabhadetails.sb_name_en}},  {{sabhadetails.sb_address}}, Tel:{{sabhadetails.sb_contact}}&nbsp; Fax:{{sabhadetails.fax}}
                   </h4>
         </div>
         <div class="row">
         <div class="col-sm-12">
            <table style="width: 100%; font-size: small;border-collapse: collapse;">
                <tbody>
                    <tr>
                        <th style="height: 20px;width: 16%; border: none; text-align: left; vertical-align: text-top;" >පදිංචිකරු වෙතටයි
                            </th>
                        <td style="height: 20px;width: 40%; border: none; text-align: left; vertical-align: text-top;">{{ ownerNamesMap[property.property_id] || 'Loading...' }}
                        </td>
                        <th style="height: 20px;vertical-align:top; width: 18%; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse; text-align: left; vertical-align: text-top;">
                            කොට්ඨාශය/வட்டாரம்/Ward
                        </th>
                        <td style="height: 20px;width: 12%; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;  ">
                            {{ getWardName(property.ward_id) }}
                        </td>
                        <td rowspan="3" style="width: 14%; border: none;  text-align: right;vertical-align:middle;">
                           <span style="font-size:xx-large; ">
                        <b>{{new Date().getFullYear()+1}}</b>
                        </span> 
                        </td>
                    </tr>
                    
                    <tr >
                        <th style="height: 20px;width: 16%; border: none; text-align: left; vertical-align: text-top;" >குடியிருப்பாளருக்கு
                            </th>
                        <td style="height: 20px;width: 40%; border: none; text-align: left; vertical-align: text-top;">{{ getStreetName(property.street_id) }}
                        </td>
                        <th style="height: 20px;vertical-align:top; width: 18%; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse; text-align: left; vertical-align: text-top;">
                            Account Number
                        </th>
                        <td style="height: 20px;width: 12%; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;  ">
                            {{ property.property_id }}
                        </td>
                       
                    </tr>
                    <tr >
                        <th style="height: 20px;width: 16%; border: none; text-align: left; vertical-align: text-top;" >To the Occupier
                            </th>
                        <td colspan="3" style="height: 20px;width: 40%; border: none; text-align: left; vertical-align: text-top;">
                            {{ property.prop_address }}({{ property.property_nature }})</td>
                      
                       
                    </tr>
                   
                </tbody>
               
                </table>
                </div>
           
        </div>
     
        <div class="row">
        <h5>1987 අංක 15 දරන ප්‍රාදේශීය සභා පනතේ විධිවිධාන ප්‍රකාරව පහත සදහන් දේපළට අදාළ තක්සේරුව පහත දැක්වේ.<br>
1987 ஆம் ஆண்டு 15ஆம் திகதி இலக்க பிரதேச சபைகள் சட்டத்தின் பிரகாரம் கீழ்காணும் ஆதனம் பின்வருமாறு மதிப்பீடு செய்யப்பட்டுள்ளது.<br>
By virtue of Pradeshiya Sabha Act no. 15 of 1987 the under mentioned property has been assessed as follows</h5>
        </div>
      
        <div class="row">
        
            <table class="ttable" style="font-size: x-small; width: 100%;  border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                <thead>
                    <tr>
                        <th colspan="4" style="text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                           තක්සේරු කරන ලද දේපළ/
/மதிப்பீடு செய்யப்பட்ட ஆதனம்
 Property Assessed
                        </th>
                        <!-- <th colspan="2"></th> -->
                        <!-- <th></th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr style="height: 45px;">
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            තක්සේරු අංකය<br>
                            வரி மதிப்பீட்டு எண்<br>
                            Assessment No.</td>
                        <td style="width: 10%; text-align: center; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.asses_num }}</td>
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            ගෙවිය යුතු වාර්ෂික වරිපනම් මුදල සහ එය අවුරුද්ද තුළ සම්පුර්ණයෙන් ගෙවීමට නියම වකවානු<br>செலுத்த வேண்டிய வருடாந்த தொகையும் செலுத்த வேண்டிய காலாண்டு திகதிகளும்<br>
                            Amount of Annual rate payble aned times of payments in for the year</td>
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            වරිපනම් ප්‍රතිශත /வரிப்பண வீதம்/
                            Rate percentage<br>(රු./ரூபா/Rs.):  {{ property.prop_rate }}%</td>
                   </tr>
                   <tr style="height: 45px;">
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            වීථිය/தெரு/Street</td>
                        <td style="width: 10%; text-align: left;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">&nbsp;&nbsp;{{ getStreetName(property.street_id) }}</td>
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            {{ parseInt(new Date().getFullYear())+1 }} මාර්තු මස 31 වන දින හෝ ඊට පෙර<br>
{{ parseInt(new Date().getFullYear())+1 }} பங்குனி(மார்ச்) மாதம் 31ஆம் திகதி அல்லது அதற்கு முன்<br>
On or Before March 31, {{ parseInt(new Date().getFullYear())+1 }}</td>
                        <td style="width: 10%; text-align: right;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.q_one_val }}&nbsp;&nbsp;</td>
                   </tr>
                   <tr style="height: 45px;">
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            {{ parseInt(new Date().getFullYear()) }} අවුරුද්දට තක්සේරු කර තිබෙන වටිනාකම<br>
{{ parseInt(new Date().getFullYear()) }} ஆம் ஆண்டிற்கு மதிப்பீடு செய்யப்பட்ட  வருடாந்த பெறுமதி<br>
Annual Value as assessed for {{ new Date().getFullYear() }}</td>
                        <td style="width: 10%; text-align: right;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.prop_value }}&nbsp;&nbsp;</td>
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            {{ parseInt(new Date().getFullYear())+1 }} ජුනි මස 30 වන දින හෝ ඊට පෙර<br>
{{ parseInt(new Date().getFullYear())+1 }} ஆனி (ஜூன்) மாதம் 30ஆம் திகதி அல்லது அதற்கு முன்<br>
On or Before June 31, {{ parseInt(new Date().getFullYear())+1 }}</td>
                        <td style="width: 10%; text-align: right;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.q_two_val }}&nbsp;&nbsp;</td>
                   </tr>
                   <tr style="height: 45px;">
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            {{ new Date().getFullYear() }} ට වාර්ෂික වරිපනම්<br>
{{ new Date().getFullYear() }} ஆண்டு மதிப்பீடு<br>
Annual assessment for {{ new Date().getFullYear() }}</td>
                        <td style="width: 10%; text-align: right;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.yearly_value }}&nbsp;&nbsp;</td>
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            {{ parseInt(new Date().getFullYear())+1 }} සැප්තැම්බර්  මස 30 වන දින හෝ ඊට පෙර<br>
{{ parseInt(new Date().getFullYear())+1 }} புரட்டாசி செப்டெம்பர் மாதம் 30ஆம் திகதி அல்லது அதற்கு முன்<br>
On or Before September 31, {{ parseInt(new Date().getFullYear())+1 }}</td>
                        <td style="width: 10%; text-align: right;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.q_three_val }}&nbsp;&nbsp;</td>
                   </tr>
                   <tr style="height: 45px;">
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            වරෙන්තු ගාස්තු (අනෙක් පිට බලන්න )<br>
தண்டப்பண வீதம் (மறுபக்கம் பார்க்கவும்)<br>
Rate of Warrant cost(refer overleaf)</td>
                        <td style="width: 10%; text-align: right;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.warrant_cost_rate }}%&nbsp;&nbsp;</td>
                        <td style="border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                           {{ parseInt(new Date().getFullYear())+1 }}  දෙසැම්බර්  මස 31 වන දින හෝ ඊට පෙර<br>
{{ parseInt(new Date().getFullYear())+1 }} மார்கழி(டிசம்பர்) மாதம் 31ஆம் திகதி அல்லது அதற்கு முன்<br>
 On or Before December 31, {{ parseInt(new Date().getFullYear())+1 }}</td>
                        <td style="width: 10%; text-align: right; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">{{ property.q_four_val }}&nbsp;&nbsp;</td>
                   </tr>
                  
                   </tbody>
            </table>
            <table  style="width: 100%; font-size: x-small; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                <tbody>
                     <tr>
                        <td colspan="2" style="text-align: justify; padding-left: 2px;padding-right: 2px; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            ඉහත සදහන් වරිපනම් මුදල ඒ ඒ කාර්තුව අනුව ප්‍රාදේශීය සභාවට ගෙවී යුතුය. යම් හෙයකින් නියමිත දිනයන්හි මුදල් නොගෙවුවහොත් වරෙන්තුවක් නිකුත් කිරීමටත් වරෙන්තු නිකුත් කිරීමේ ගාස්තුව සමඟ අදාළ මුදල අයකර ගැනීමටත් පියවර ගනු ලැබේ.
                        </td>
                        <td style="font-size: xx-small; text-align: justify; padding-left: 2px;padding-right: 2px;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            மேற் குறிப்பிட்ட வரித்தொகையை பிரதேச சபைக்கு குறித்த காலத் தவணைக்குள் செலுத்த வேண்டுமென அறிவுறுத்தப்படுகிறீர்கள்.குறிக்கப்பட்ட காலத்தவணைக்குள் மேற்குறிப்பிட்ட 
                            வரி செலுத்தப்படாவிட்டால் அப்பணம் எழுத்தாணை அனுப்பி செலவுத் தொகையுடன் அறவிடப்படும். 
                        </td>
                        <td  style="text-align: justify;padding-left: 2px;padding-right: 2px; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            You are here by require to pay the amount of the above rate or rates at Pradeshiya sabha in the proportions 
                            and at the times shown above, in failure whereof a warrant will be issued by the Pradeshiya Saabhafor 
                            the recovery of the same with costs.
                        </td>
                        
                   </tr>
                    <tr style="height: 130px;">
                        <td colspan="2" style="text-align: center; vertical-align: top; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                        <br>  
                        නීති ප්‍රකාර දැන්වීම භාරදුන් දාතමය<br>
சட்டரீதியான அறிவித்தல் கொடுக்கப்பட்ட திகதி <br>
Date of Service of Statutory Notice<hr style="width: 95%;border: 1px solid #000; margin: 1em auto;">
                        </td>
                        <td style="width: 33%; text-align: center; vertical-align:bottom; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                            <hr style="width: 95%;border: 1px solid #000; margin: 1em auto;">
                            භාරගන්නා අයගේ අත්සන<br>
பாரமெடுப்பவரின் கையொப்பம்<br>
Signature of Recipient<br><br>
                        </td>
                         <td style="width: 33%; text-align: center; vertical-align:bottom;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;"> <hr style="width: 95%;border: 1px solid #000; margin: 1em auto;">
                            ලේකම්/සභාපති<br>
காரியதரிசி/தலைவர்<br>
Secretary/Chairman<br><br></td>
                        
                   </tr>
                   
                </tbody>
            </table>
        </div>
        <br>
        </div>
        </div>
                   <br>
<!-- --------------------------------------------------------------------------------------------------------------------------------- -->
             <div ref="listContent" class="pdf-hidden-content" id="list-content" >
        <h3 style="text-align: center;">
            List of Statutary Assessment Notice</h3>
        <h3 style="text-align: center;">{{  getWardName(CatObj.ward) }} - {{ getStreetName(CatObj.street) }} &nbsp;{{ CatObj.side }}
        

        </h3>
        <!-- <div  class="list-block"> -->
            <table class="ttable" style="font-size: x-small; width: 100%;  border-width: 0.5px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                <tr>
                   <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    Index
                    </th>
                    <th style="height: 20px;width: 15%;text-align: left;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    Name
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    Assessment No.
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    Account<br> Number
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    Annual Value <br>as Assessed for {{new Date().getFullYear()}}(Rs.)
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                     Payment <br>percentage(%)
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    Annual Assessment <br>for {{new Date().getFullYear()}}(Rs.)
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    Warrant Cot Rate(%)
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                     Date <br>of Service
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                     Signature <br>of Server
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                     Received Date
                    </th>
                    <th style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                     Signature <br>of Owner/Occupier
                    </th>
                </tr>
                <tr v-for="(property, index) in propertydetails" :key="index" >
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{ index+1 }}
                    </td>
                     <td style="height: 20px;padding-left: 2px; width: 15%;text-align: left;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{ ownerNamesMap[property.property_id] || 'Loading...'  }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{ property.asses_num }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{property.property_id  }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{ property.prop_value }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{ property.prop_rate }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{property.yearly_value  }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{ property.warrant_cost_rate }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{  }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{  }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{  }}
                    </td>
                    <td style="height: 20px;text-align: center;border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                    {{  }}
                    </td>
                </tr>
            </table>

        <!-- </div> -->
     </div>
<!-- ------------------------------------------------------------------------------------------------------------------------- -->
        </div>
    </div>
  <!-- <button @click="previewPDF">Preview & Download PDF</button>
   -->
</template>

<script>
import axios from "axios";
import VueBasicAlert from 'vue-basic-alert';
import html2pdf from 'html2pdf.js';
//import { ref } from 'vue'
export default {

    name: "Kform",

    data() {
        return {
             CatObj : { ward:"", street:"",  mainc:"" ,propsearch:"",assenum:"",side:""},
                    aserrObj:{ wardErr:[], stretErr:[]},
            matchHead: undefined,
            ratehead : '',
            nic:"",
            sabha: "",
             sabaProp:[],
            userLevel:"",
            savedbanks:[],
            sabhadetails:[],
            savedWards:[],
            savedStreets:[],
            propertydetails:[],
             propertydetailsOwners:[],
            propDetails:[],
            propObj:{asspropId:"",assnum:"",street:"",ward:"",annualvalue:"",annualassvalue:"",warrantrate:"",arrears:"",
                ratepercentage:"",qoneval:"",qtwoval:"",qthreeval:"",qfourval:""
            },
            ownerdetails:[],
            PropOwnerObj:{owner:"",address:""},
            ownerNames: {},
    ownerAddresses: {},
     loading: false
        }
    },

    created() {
        this.getDataFromSessionStorage()
       
      
    },
   computed: {
        ownerNamesMap() {
            const map = {};
            this.propertydetails.forEach(prop => {
            const owners = this.propertydetailsOwners.filter(
                p => p.property_id === prop.property_id
            );
            if (!owners.length) {
                map[prop.property_id] = 'No Owner';
            } else {
                map[prop.property_id] = owners
                .map(o => (o.owner_name?.trim() || o.owner_nic || 'No Owner'))
                .join(', ');
            }
            });
            return map;
        }
        },

    methods: {
        async getDataFromSessionStorage(){
            const data = JSON.parse(sessionStorage.getItem('userData'))
            if(data){
                            this.nic = data.nic 
                            this.sabha = data.sabha
                            this.userLevel =data.userLevel
                        }
        this.savedbanks= (await axios.get('/sabhaaccounts/'+this.sabha)).data;
         this.sabhadetails= (await axios.get('/pra_sabha/' +this.sabha)).data
         try{
              this.sabaProp = (await axios.get('/props/' +this.sabha)).data                       
          } catch (error) {
              console.error("Error fetching data", error);
          }
          this.savedWards= (await axios.get('/wdbys/'+this.sabha)).data;
           this.savedStreets = (await axios.get('/stbys/'+this.sabha)).data;
           this.propertydetailsOwners=(await axios.get('/sabhaprownerdetails/'+this.sabha)).data;
        },

printpdf() {
    const prtHtml = this.$refs.pdfContent.innerHTML;
    const WinPrint = window.open('', '', 'width=1000,height=700');

    WinPrint.document.write(`
      <html>
        <head>
          <title>Statutory Notice of Assessment</title>
          <style>
            @page {
              size: A4 landscape;
              margin: 15mm;
            }

            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
            }

            .property-block {
              page-break-after: always;
            }

            .property-block:last-child {
              page-break-after: auto;
            }

           
          </style>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>
    `);

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();

    setTimeout(() => {
      WinPrint.close();
    //   this.$router.push('/invoice');
    }, 500);
}

,

            
    previewPDF() {
  const element = this.$refs.pdfContent;

  const options = {
    margin: 0.3,
    filename: 'Assessment_Report.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
  };

  this.$nextTick(() => {
    html2pdf()
      .set(options)
      .from(element)
      .outputPdf('blob')
      .then(blob => {
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL); // Open PDF in a new tab for preview
      });
  });
},
async downloadPDF() {
  this.loading = true; // Show loader
  document.getElementById('loadingOverlay').style.display = 'flex';

  document.getElementById("list-content").style.display = "block";

  await this.$nextTick();

  const el = this.$refs.listContent;

  if (!el || !el.innerHTML.trim()) {
    console.error("Element is missing or has no content");
    this.loading = false; // Hide loader on error
    document.getElementById('loadingOverlay').style.display = 'none';

    
    return;
  }

  const options = {
    margin: 0.3,
    filename: 'Assessment_Report.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };

  try {
    setTimeout(() => {
      html2pdf()
        .set(options)
        .from(el)
        .outputPdf('blob')
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        })
        .finally(() => {
          this.loading = false; // Hide loader
          document.getElementById('loadingOverlay').style.display = 'none';

        });
    }, 300);
  } catch (error) {
    console.error("PDF generation error:", error);
    this.loading = false; // Hide loader
    document.getElementById('loadingOverlay').style.display = 'none';

  }
},
      getWardName(ward_id) {
      const ward = this.savedWards.find(m => m.ward_id === ward_id);
      return ward ? ward.ward : 'Unknown';  // Return 'Unknown' if ward_id is not found
        },
        getStreetName(street_id) {
            const street = this.savedStreets.find(m => m.street_id === street_id);
            return street ? street.street_name : 'Unknown';
        },
       

       async SearchByward() {
         
          this.selectedProperty= null;
              const url = `/wardproplist/${this.sabha}/${this.CatObj.ward}`;
              // const url = `/sabapropid/${this.rentObj.pra_sabha}/${this.CatObj.assenum}`;
            //   await this.fetchData(url);
              const response = await axios.get(url);
          this.propertydetails = response.data;
         
      },
      async SearchByraod() {
         
        if (!this.CatObj.ward) {
             this.aserrObj.wardErr.push("please select ward");
         }else{
           this.resetCheckErras();
          this.selectedProperty= null;
              const url = `/streetproplist/${this.sabha}/${this.CatObj.ward}/${this.CatObj.street}`;
              // const url = `/sabapropid/${this.rentObj.pra_sabha}/${this.CatObj.assenum}`;
            //   await this.fetchData(url);
              const response = await axios.get(url);
           this.propertydetails = response.data;
        //   this.propDetails =  (await axios.get('/sabapropid/'+ this.sabha+"/"+ this.CatObj.assenum)).data
         }
      },
      checkFormas: function () {
         this.resetCheckErras();
         if (!this.CatObj.ward) {
             this.aserrObj.wardErr.push("please select ward");
         }
         if (!this.CatObj.street) {
             this.aserrObj.stretErr.push("please select street");
         }
       
     },
     resetCheckErras: function () {
      this.aserrObj.wardErr =[];
      this.aserrObj.stretErr=[];
     },
     checkEmptyErras: function () {
         for (var typeErr in this.aserrObj) {
             if (this.aserrObj[typeErr].length != 0) {
                 return false;
             }
         }
         return true;
     },
      async SearchByside() {
         this.checkFormas();
                   if (!this.checkEmptyErras()) {
                     //  
                     this.$refs.alert.showAlert('error','Fill Required Field !')
                   } else {
                     
          this.selectedProperty= null;
              const url = `/streetsideproplist/${this.sabha}/${this.CatObj.ward}/${this.CatObj.street}/${this.CatObj.side}`;
              // const url = `/sabapropid/${this.rentObj.pra_sabha}/${this.CatObj.assenum}`;
            //   await this.fetchData(url);
              const response = await axios.get(url);
           this.propertydetails = response.data;
        //   this.propDetails =  (await axios.get('/sabapropid/'+ this.sabha+"/"+ this.CatObj.assenum)).data
                   }
      },

      
      async genByAssNum(){

         const response = await axios.get(`/prownerdetailsowners/${this.CatObj.assenum}/${this.sabha}`);

        if (response.data && response.data.length > 0) {
      this.ownerdetails = response.data;

      // Join multiple names into a single string (e.g., comma-separated)
      this.PropOwnerObj.owner = this.ownerdetails.map(owner => owner.cus_name).join(', ') || "";

    // Assign the first address found
    this.PropOwnerObj.address= this.ownerdetails[0].prop_address || "";
    this.propObj.assnum=this.ownerdetails[0].asses_num;
    this.propObj.asspropId=this.ownerdetails[0].property_id;

         this.propertydetails=(await axios.get('/sabapropid/'+ this.sabha+"/"+ this.CatObj.assenum)).data;
      
               
        }
      },
//      async getPropOwners(proid) {
//     try {
//       const response = await axios.get(`/prownerdetails/${proid}/${this.sabha}`);
//       const ownerdetails = response.data;

//       if (ownerdetails && ownerdetails.length > 0) {
//         const ownerName = ownerdetails.map(owner => owner.cus_name).join(', ') || "";
       
//         // store them in your state
//         this.$set(this.ownerNames, proid, ownerName);
       
//       } else {
//         this.$set(this.ownerNames, proid, "");
     
//       }
//     } catch (error) {
//       console.error("Error fetching owners:", error);
//       this.$set(this.ownerNames, proid, "");
     
//     }
//   },


        resetCheckErr: function () {
            this.errorObj.accNumErr = [];
            this.errorObj.bankErr = [];
          
        },
        checkEmptyErr: function () {
            for (var typeErr in this.errorObj) {
                if (this.errorObj[typeErr].length != 0) {
                    return false;
                }
            }
            return true;
        },
        checkForm: function () {
            this.resetCheckErr();

            // Head Id/code validate
            if (!this.bankObj.accNum) {
                this.errorObj.accNumErr.push("Account Number is required");
            }

            // Rate Head validate
            if (!this.bankObj.bank){
                this.errorObj.bankErr.push("Bank details field is required");
            }
             
        },
        
        async handleSubmit(e) {
            this.checkForm();


            if (!this.checkEmptyErr()) {
                e.preventDefault();
            } else {
                e.preventDefault();
                await this.matchAccNum(this.bankObj.accNum);
                if (this.matchAcc) {
                    this.errorObj.bankErr.push("Account Number already exist")
                }
                else {
                    let data = {
                       
                        prs_code : this.sabha ,
                        acc_no: this.bankObj.accNum ,
                        bank: this .bankObj.bank,
                        
                    }
                    await axios.post("/savebank/", data)
                    this.$refs.alert.showAlert('success', 'Bank Details Added Successfully !')
                   
                    this.savedbanks= (await axios.get('/sabhaaccounts/'+this.sabha)).data
                    document.getElementById("addBankAccForm").reset()
                    this.bankObj.accNum ="",
                    this .bankObj.bank =""
                
                }
            }
        }

    },
    components: {
        VueBasicAlert
    }
}
</script>

<style scoped>
.print-container {
  padding: 20px;
  background: white;
  font-family: 'Arial', sans-serif;
}

.property-block {
  margin-bottom: 20px;
  page-break-after: always;
}
.listContent {
  padding: 20px;
  background: white;
  font-family: 'Arial', sans-serif;
}

.pdf-hidden-content{
  margin-bottom: 20px;
  page-break-after: always;
  display: none;
}
button {
  margin-bottom: 20px;
  padding: 10px 20px;
  font-weight: bold;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
/* new */
.ttable {
     
     width: 100%;
     border-width:2px;
     border-color : #130f40;
     /* border-style: solid; */
     font-size: 1.2rem;
     /* background-color :white; */
     /* padding-left: 3rem; */
      /* height: 3rem; */
 }
 th  {
     text-align: center;
}
.ttable, th, td {
border: 1px solid;
text-align: left;
height: 45px;
}

.ttable, tr {
height: 15%;
}



.register-container {
    padding: 2rem 2%;
    min-height: 72.3vh;
}

.register-container .register-form-container {
    background: #fff;

}

.register-container .register-form-container form {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
    /* max-width: 70rem; */
    width: 100%;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
    border: 0.1rem solid rgba(0, 0, 0, 0.2);
    padding: 2rem;
    border-radius: 0.5rem;
    animation: fadeUp 0.4s linear;
}

.register-container .register-form-container form h3 {
    padding-bottom: 1rem;
    font-size: 1.8rem;
    text-transform: uppercase;
    color: #130f40;
    margin: 0;
}

.register-container .register-form-container form .form-control {
     margin: 0.7rem 0;
    border-radius: 0.5rem;
    background: #f7f7f7;
    /* padding: 2rem 1.2rem; */
     font-size: 1.6rem; 
    color: #130f40;
    text-transform: none;
    width: 100%;
    border: margin-bottom; 
} 

.register-container .register-form-container form label {
    font-size: 1.5rem;
    margin: 0;
    padding: 0;
}

.register-container .register-form-container form span {
    font-size: 18px;
    padding-left: 5px;
    padding-right: 40px;
     color: #4e0707;
}
.btn {
    margin: 1rem 0;
    width: 20%;
    text-align: center;
    background-color:#4e0707 ;
font-size: 12px;
    
}

.register-container .register-form-container form p {
    padding-top: 1rem;
    font-size: 1.5rem;
    color: #666;
    margin: 0;
}

.register-container .register-form-container form p a {
    color: #27ae60;
}

.register-container .register-form-container form p a:hover {
    color: #130f40;
    text-decoration: underline;
}

.register-container .register-form-container form .form-group {
    margin: 0;
}

.register-container .register-form-container form .error-mess {
    font-size: 1.5rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 0;
    padding: 0;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 6px solid #ccc;
  border-top: 6px solid #130f40;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 10px;
  font-size: 18px;
  color: #130f40;
  font-weight: bold;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>